module.exports = __webpack_public_path__ + "static/media/flora1216-彩钢公寓.58b4f2d8.pdf";